// constants
import { LogsActionTypes } from "./constants";

//Action
export interface LogsActionType {
  type:
    | LogsActionTypes.GET_LIST_LOGS
    | LogsActionTypes.GET_LIST_LOGS_SUCCESS
    | LogsActionTypes.GET_LIST_LOGS_ERROR
    | LogsActionTypes.GET_LOG
    | LogsActionTypes.GET_LOG_SUCCESS
    | LogsActionTypes.GET_LOG_ERROR;
  payload: {} | string;
}

//Interfaces
interface LogsData {
  items?: any[];
  total?: number;
  keyword?: string;
  limit?: number;
  skip?: number;
  action?: string;
  entity?: string;
  user?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
}

interface GetLog {
  id: string;
}

//Log_List
export const LogsGetListSuccess = (
  actionType: string,
  data: LogsData | {}
): LogsActionType => ({
  type: LogsActionTypes.GET_LIST_LOGS_SUCCESS,
  payload: { actionType, data },
});

export const LogsGetListError = (
  actionType: string,
  error: string
): LogsActionType => ({
  type: LogsActionTypes.GET_LIST_LOGS_ERROR,
  payload: { actionType, error },
});

export const getLogsList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  action: string = "",
  entity: string = "",
  user: string = "",
  country: string = "",
  startDate: string = "",
  endDate: string = ""
): LogsActionType => ({
  type: LogsActionTypes.GET_LIST_LOGS,
  payload: {
    keyword,
    limit,
    skip,
    action,
    entity,
    user,
    country,
    startDate,
    endDate,
  },
});

//GET Log
export const getLogSuccess = (
  actionType: string,
  data: GetLog | {}
): LogsActionType => ({
  type: LogsActionTypes.GET_LOG_SUCCESS,
  payload: { actionType, data },
});

export const getLogError = (
  actionType: string,
  error: string
): LogsActionType => ({
  type: LogsActionTypes.GET_LOG_ERROR,
  payload: { actionType, error },
});

export const getLog = (id: string): LogsActionType => ({
  type: LogsActionTypes.GET_LOG,
  payload: { id },
});
